import PropTypes from 'prop-types'
import Draw from './draw'
import { buildStyle } from '../style'

//ol
import OlDraw from 'ol/interaction/Draw'

export default class DrawPoint extends Draw {
  createInteraction(props, context) {
    return new OlDraw({
      type: 'Point',
      style: buildStyle(props.style),
      source: context.source
    })
  }
}

DrawPoint.propTypes = {
  active: PropTypes.bool,
  drawstart: PropTypes.func,
  drawend: PropTypes.func,
  style: PropTypes.arrayOf(PropTypes.object)
}
